import EventEmitter from 'eventemitter3';
import router from './../router';
import client from './../lib/http-client';

export default class AuthService {
	constructor() {
		this.setSession = this.setSession.bind(this);
		this.setLocalSession = this.setLocalSession.bind(this);
		this.loginSuccess = this.loginSuccess.bind(this);
		this.logout = this.logout.bind(this);
		this.isAuthenticated = this.isAuthenticated.bind(this);
	}

	authenticated = this.isAuthenticated();
	authNotifier = new EventEmitter();

	// eslint-disable-next-line
	loginSuccess(store) {
		store.dispatch('login');
		router.replace('/events');
	}

	setSession(accessToken) {
		// set access_token
		localStorage.setItem('access_token', accessToken);
		client.defaults.headers.Authorization = `Bearer ${accessToken}`;
		this.authNotifier.emit('authChange', { authenticated: true });
	}

	setLocalSession(data) {
		const token = data.token;
		const store = data.store;
		localStorage.setItem('access_token', token);
		client.defaults.headers.Authorization = `Bearer ${token}`;
		this.loginSuccess(store);
	}

	logout() {
		// Clear Access Token from local storage
		// navigate to the home route
		localStorage.removeItem('access_token');
		this.userProfile = null;
		this.authNotifier.emit('authChange', false);
		router.replace('login');
	}

	// eslint-disable-next-line
	isAuthenticated() {
		return true;
	}
}
